import Wave from 'react-wavify'
// components
import Profile from './organisms/Profile';
import Guidelines from './organisms/Guidelines';
import Shop from './organisms/Shop';
import Gallery from './organisms/Gallery';
// img
import standing from '../images/standing.png';
import whiteLogo from '../images/logo-white.png';
// style
import '../style/top.css';

const Top = (props :any) => {
  return (
    <div>
      <div id='top'>
        <div className='content-wrap'>
          <div className='charactor'>
            <img src={standing} alt="kanami"/>
          </div>
        </div>
        <div className='wave-wrap'>
          <div className='logo'>
            <img src={whiteLogo} alt="logo"/>
          </div>
          <Wave
            fill='#a5d2fd'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 5
            }}
          />
          <div className='wave-background'/>
        </div>
        <div className='wave-wrap1'>
          <Wave
            fill='#c3e2ffff'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 6
            }}
          />
        </div>
        <div className='wave-wrap2'>
          <Wave
            fill='#fff'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 4
            }}
          />
        </div>
      </div>
      <div id='profile'>
        <Profile />
      </div>
      <div id='shop'>
        <div className='wave-wrap1'>
          <Wave
            fill='#e4f2ff'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 5
            }}
          />
        </div>
        <Shop/>
        <div className='wave-wrap2'>
          <Wave
            fill='#a5d2fd'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 5
            }}
          />
        </div>
        <div className='wave-wrap3'>
          <Wave
            fill='#fff'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 4
            }}
          />
        </div>
      </div>
      <div id='gallery'>
        <Gallery />
      </div>
      <div id='guidelines'>
        <div className='wave-wrap1'>
          <Wave
            fill='#a5d2fd'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 4
            }}
          />
        </div>
        <div className='wave-wrap2'>
          <Wave
            fill='#d1e9ff'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 3
            }}
          />
        </div>
        <Guidelines />
        <div className='wave-wrap3'>
          <Wave
            fill='#fff'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 15,
              speed: 0.15,
              points: 4
            }}
          />
        </div>
      </div>
      <div className='copy'>
        🄫 2024 花波-kanami-
      </div>
    </div>
  );
};

export default Top;